import { envSchema, EnvSchema } from "./EnvSchema";

declare global {
  var import_meta_env: EnvSchema | string;
}

export const env = envSchema.parse(
  globalThis?.import_meta_env !== "import_meta_env_placeholder"
    ? globalThis?.import_meta_env
    : import.meta.env
);
